import "@/App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import FundList from "@/pages/FundList";
import FundDetail from "@/pages/FundDetail";
import Compare from "@/pages/Compare";
import AmcScorecard from "@/pages/AmcScorecard";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import TermsOfService from "@/pages/TermsOfService";
import Enquiries from "@/pages/Enquiries";

function App() {
  return (
    <div className="App flex flex-col min-h-screen justify-between">
      <BrowserRouter>
        <div>
          <Header />
          <Routes>
            <Route path="/" element={<FundList />} />
            <Route path="/fund/:code" element={<FundDetail />} />
            <Route path="/compare" element={<Compare />} />
            <Route path="/amcs" element={<AmcScorecard />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsOfService />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
            <Route path="/enquires" element={<Enquiries />} />
            <Route path="/enquiries" element={<Enquiries />} />
          </Routes>
        </div>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;

